export default "__VITE_ASSET__$dzGJr1f__"